<template>
  <div>
    <div class="banner" :style="cover">
      <h1 class="banner-title">日志明细</h1>
    </div>
    <v-card class="blog-container blog_container_for_log">
      <ve-table
        class="tableContainer"
        id="loading-container"
        :columns="columns"
        :table-data="tableData"
        :row-style-option="rowStyleOption"
      />
      <div class="table-pagination">
        <ve-pagination
          :total="totalCount"
          :page-index="pageIndex"
          :page-size="pageSize"
          @on-page-number-change="pageNumberChange"
          @on-page-size-change="pageSizeChange"
          :paging-count="isMobile ? 2 : 4"
        />
      </div>

      <p class="message-tip">
        #如需关闭记录日志，请前往
        <router-link to="/setting" style="color: #1976d2"
          >“设置”页面</router-link
        >进行配置
      </p>
    </v-card>
  </div>
</template>

<script>
import { userConsumeLogList } from "../../api";
import zhCN from "vue-easytable/libs/locale/lang/zh-CN";
import { initModelConfigList, getModelKeyName } from "@/config/modelConfig";

export default {
  metaInfo: {
    meta: [
      {
        name: "keyWords",
        content:
          "兮游,seayouth,兮游博客,seayouth博客,chatgpt,AI绘图,AI作品图集,AI语音,游戏模拟器", //变量或字符串
      },
      {
        name: "description",
        content:
          "一个专注于AI技术分享的博客平台,无论您是AI爱好者、学者、开发者，还是对AI应用有兴趣的读者，这里都能为您提供有价值的内容和思考",
      },
    ],
  },
  data: function() {
    return {
      rowStyleOption: {
        stripe: true,
      },
      loadingInstance: null,
      // page index
      pageIndex: 1,
      // page size
      pageSize: 10,
      type: "",
      model: "",
      totalCount: 0,
      columns: [
        {
          field: "createDate",
          key: "createDate",
          title: "时间",
          align: "left",
        },
        {
          field: "type",
          key: "type",
          title: "分类",
          align: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span class="typeSpanClass">{row[column.field]}</span>;
          },
          // filter
          filter: {
            filterList: [
              {
                value: 0,
                label: "AI问答",
                selected: false,
              },
              {
                value: 1,
                label: "AI绘画",
                selected: false,
              },
              {
                value: 2,
                label: "AI音频",
                selected: false,
              },
              {
                value: 3,
                label: "充值",
                selected: false,
              },
            ],
            // filter confirm hook
            filterConfirm: (filterList) => {
              const labels = filterList
                .filter((x) => x.selected)
                .map((x) => x.label);
              this.type = labels[0];
              this.getLogs();
            },
            // filter reset hook
            filterReset: (filterList) => {
              this.type = null;
              this.getLogs();
            },
          },
        },
        {
          field: "model",
          key: "model",
          title: "模型",
          align: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return <span class="modelSpanClass">{row[column.field]}</span>;
          },
          filter: {
            filterList: [],
            // filter confirm hook
            filterConfirm: (filterList) => {
              const labels = filterList
                .filter((x) => x.selected)
                .map((x) => x.label);
              this.model = labels[0];
              this.getLogs();
            },
            // filter reset hook
            filterReset: (filterList) => {
              this.model = null;
              this.getLogs();
            },
          },
        },
        {
          field: "quotaTypeStr",
          key: "quotaTypeStr",
          title: "配额类型",
          align: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            const text = row[column.field];
            if (text === "免费") {
              return (
                <span class="QuotaTypeStrFreeSpanClass">
                  {row[column.field]}
                </span>
              );
            } else if (text === "充值") {
              return (
                <span class="QuotaTypeStrRechargeSpanClass">
                  {row[column.field]}
                </span>
              );
            } else {
              return <span class="QuotaTypeStrSpanClass">消费</span>;
            }
          },
        },
        {
          field: "durationStr",
          key: "durationStr",
          title: "用时",
          align: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            var duration =
              (this.tableData[rowIndex].duration * 80) / 1000 / 150;
            if (duration > 80) duration = 80;
            // const text = row[column.field];
            const text = "width:" + duration + "px";
            if (duration >= 80) {
              return (
                <span class="durationStrSpanClass">
                  <span class="durationStrSub3SpanClass" style={text}>
                    <span class="durationStrTextSpanClass">
                      {row[column.field]}
                    </span>
                  </span>
                </span>
              );
            } else if (duration > 40) {
              return (
                <span class="durationStrSpanClass">
                  <span class="durationStrSub2SpanClass" style={text}>
                    <span class="durationStrTextSpanClass">
                      {row[column.field]}
                    </span>
                  </span>
                </span>
              );
            } else {
              return (
                <span class="durationStrSpanClass">
                  <span class="durationStrSub1SpanClass" style={text}>
                    {" "}
                  </span>
                  <span class="durationStrTextSpanClass">
                    {row[column.field]}
                  </span>
                </span>
              );
            }
          },
        },
        {
          field: "quota",
          key: "quota",
          title: "配额",
          align: "left",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            var quota = -1 * row[column.field];
            // console.log(row[column.field]);
            // console.log(quota);
            if (quota > 0) {
              return <span>+{quota}</span>;
            } else {
              return <span>{quota}</span>;
            }
          },
        },
        { field: "score", key: "score", title: "获得积分", align: "left" },
        { field: "detail", key: "detail", title: "详细信息", align: "left" },
        { field: "rule", key: "rule", title: "规则说明", align: "left" },
      ],
      tableData: [],
    };
  },
  async mounted() {
    this.$veLocale.use(zhCN);
    this.loadingInstance = this.$veLoading({
      target: document.querySelector("#loading-container"),
      // 等同于
      // target:"#loading-container"
      name: "wave",
    });
    await this.initModelFilter();
    this.$nextTick(() => {
      // 强制更新表格组件
      if (this.$refs.veTable) {
        this.$refs.veTable.updateColumns();
      }
    });

    this.getLogs();
  },
  methods: {
    async initModelFilter() {
      try {
        const modelConfigsList = await initModelConfigList(true);

        // 创建新的列配置
        const newColumns = [...this.columns];
        const modelColumnIndex = newColumns.findIndex(
          (col) => col.key === "model"
        );

        if (modelColumnIndex !== -1) {
          // 创建新的过滤器配置
          const newFilterList = [
            ...modelConfigsList.map((model, index) => ({
              value: index,
              label: model.displayName || model.label.split("[")[0].trim(),
              selected: false,
              modelKey: model.value,
            })),
            // 添加固定的选项
            {
              value: modelConfigsList.length,
              label: "MidJourney慢速",
              selected: false,
              modelKey: "MidJourney",
            },
            {
              value: modelConfigsList.length + 1,
              label: "MidJourney快速",
              selected: false,
              modelKey: "MidJourney_FAST",
            },
            {
              value: modelConfigsList.length + 2,
              label: "Suno.AI-V3",
              selected: false,
              modelKey: "SUNO_AI_V3",
            },
          ];

          // 更新列配置
          newColumns[modelColumnIndex] = {
            ...newColumns[modelColumnIndex],
            filter: {
              ...newColumns[modelColumnIndex].filter,
              filterList: newFilterList,
            },
          };

          // 更新整个 columns 数组
          this.columns = newColumns;
        }
      } catch (error) {
        console.error("初始化模型过滤器失败:", error);
        this.$message.error("加载模型列表失败，请刷新重试");
      }
    },
    getLogs() {
      this.loadingInstance.show();
      var typeReal = "";
      var modelReal = "";
      switch (this.type) {
        case "ChatGPT":
        case "AI问答":
          typeReal = "CHATGPT";
          break;
        case "AI绘画":
          typeReal = "AIART";
          break;
        case "AI音频":
          typeReal = "AIAUDIO";
          break;
        case "充值":
          typeReal = "RECHARGE";
          break;
        default:
          break;
      }
      switch (this.model) {
        case "MidJourney慢速":
          modelReal = "MidJourney";
          break;

        case "MidJourney快速":
          modelReal = "MidJourney_FAST";
          break;
        case "Suno.AI-V3":
          modelReal = "SUNO_AI_V3";
          break;
        default:
          modelReal = getModelKeyName(this.model);
          break;
      }
      userConsumeLogList({
        pageNo: this.pageIndex,
        pageSize: this.pageSize,
        type: typeReal,
        model: modelReal,
      })
        .then((res) => {
          this.tableData = res.data.records;
          this.totalCount = res.data.total;
          this.loadingInstance.close();
        })
        .catch((err) => {});
    },
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getLogs();
    },
    pageSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getLogs();
    },
  },
  computed: {
    cover() {
      var cover = "";
      this.$store.state.blogInfo.pageList.forEach((item) => {
        if (item.pageLabel == "log") {
          cover = item.pageCover;
        }
      });
      return "background: url(" + cover + ") center center / cover no-repeat";
    },
    isMobile() {
      const clientWidth = document.documentElement.clientWidth;
      if (clientWidth > 760) {
        return false;
      }
      return true;
    },
  },
  destroyed() {
    this.loadingInstance.destroy();
  },
};
</script>

<style>
.table-pagination {
  margin-top: 20px;
  text-align: right;
}

.typeClass {
  padding: 4px 8px;
  background-color: rgb(139 184 8) !important;
  color: rgb(72 104 0) !important;
}

.modelSpanClass {
  padding: 4px 8px;
  background-color: rgb(139 184 8 / 16%) !important;
  color: rgb(72 104 0) !important;
  border-radius: 2px 4px;
}
.typeSpanClass {
  padding: 4px 8px;
  background-color: #7acaff36 !important;
  color: #2b7fc4d2 !important;
  border-radius: 2px 4px;
}
.durationStrSpanClass {
  display: inline-block;
  width: 80px;
  background-color: #7acaff36 !important;
}
.durationStrSub1SpanClass {
  display: inline-block;
  background-color: #2afa7a36 !important;
}
.durationStrSub2SpanClass {
  display: inline-block;
  background-color: #ffc3005e !important;
}
.durationStrSub3SpanClass {
  display: inline-block;
  background-color: #fa2a2a36 !important;
}
.durationStrTextSpanClass {
  font-size: small;
  font-weight: 200;
  margin-left: 4px;
}
.QuotaTypeStrFreeSpanClass {
  color: #33333399;
}
.QuotaTypeStrRechargeSpanClass {
  color: #15b151d5;
}
@media (max-width: 759px) {
  .tableContainer * {
    font-size: 10px !important;
    padding: 2px 4px 2px 0px !important;
  }
  .ve-pagination .ve-pagination-goto {
    display: none !important;
  }
  .ve-pagination .ve-pagination-total {
    display: none !important;
  }
  .ve-pagination .ve-pagination-select {
    display: none !important;
  }
}
@media (min-width: 760px) {
}
.ve-table-container {
  overflow-y: hidden !important;
}
.message-tip {
  font-size: 10px;
  bottom: 14px;
  font-style: italic;
  left: 4px;
  color: #aaa;
  margin-bottom: 4px;
  font-style: italic;
}
</style>
